import { HtmlGenerator } from '@utils';
import { store } from '../store';
import { SubmissionEntityInterface } from '@types';
import { ICSMessage } from './ICSMessage';

export const generateSubmissionICS = (
  letterName: string,
  submission: SubmissionEntityInterface
) => {
  const submissionEnvironment = store?.getState().submissionEnvironment;
  const submissionFormData = JSON.parse(submission.origin.form.data);
  const html = new HtmlGenerator(
    submission.origin.formRenderer.data,
    submissionEnvironment,
    true
  ).getHtml(true);

  const subject = new HtmlGenerator(submissionFormData?.subject, submissionEnvironment).getHtml();
  const to = {
    name: new HtmlGenerator(submissionFormData.recipientName, submissionEnvironment).getHtml(),
    email: new HtmlGenerator(submissionFormData.recipientEmail, submissionEnvironment).getHtml(),
  };
  const message = new ICSMessage(subject, to, html);
  message.createMessage();
};
